import { Fade, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import HomeLayout from 'layouts/home-layout';
import ClientAcivity from 'pages/common/client/client-activity';

import AdminActions from './components/admin-actions';
import AllClients from './components/all-clients';

const useStyles = makeStyles(() => ({
  container: {
    padding: '5%',
    flexGrow: 1,
  },
}));

const SuperAdminDashboard = () => {
  const classes = useStyles();

  return (
    <HomeLayout showPortalName={false}>
      <Fade in={true}>
        <div className={classes.container}>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <AdminActions />
            </Grid>
            <Grid item md={6} xs={12}>
              <ClientAcivity />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <AllClients />
            </Grid>
          </Grid>
        </div>
      </Fade>
    </HomeLayout>
  );
};
export default SuperAdminDashboard;
